module.exports = __webpack_public_path__ + "static/media/choithramsSmallBanner.1d44fd07.png";